import React from 'react';
import Icon from '../Icon';
import svg from '../icons/close.js';

const IconClose = (props) => <Icon {...props} svg={svg} />;

IconClose.displayName = 'IconClose';

export default IconClose;
